module.exports = __webpack_public_path__ + "static/media/pamain-bold.86db912d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-bold.svg
// module id = ./src/assets/fonts/pamain-bold.svg
// module chunks = 0